export const create = {
  createSuccessfully: '水洗機部品の新規作成に成功しました。',
  createFailed: '水洗機部品の新規作成に失敗しました。',
}
